import React from 'react'
import style from './PauseBtn.module.scss'

export const PauseBtn = ({ handle = () => {}, value }) => {
	const handleClick = () => {
		handle(value)
	}
	return (
		<svg
			version='1.0'
			viewBox='0 0 512.000000 512.000000'
			className={style.pause}
			onClick={handleClick}
		>
			<g
				transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
				className={style.pause__G}
			>
				<path d='M695 5106 c-156 -39 -272 -168 -295 -327 -13 -85 -13 -4353 0 -4438 23 -164 146 -295 308 -330 73 -15 1071 -15 1144 0 162 35 285 166 308 330 13 85 13 4353 0 4438 -23 164 -146 295 -308 330 -77 16 -1089 14 -1157 -3z' />
				<path d='M3255 5106 c-157 -39 -272 -167 -296 -329 -5 -35 -9 -988 -9 -2217 0 -1229 4 -2182 9 -2217 24 -167 146 -297 309 -332 73 -15 1071 -15 1144 0 162 35 285 166 308 330 13 85 13 4353 0 4438 -23 164 -146 295 -308 330 -77 16 -1089 14 -1157 -3z' />
			</g>
		</svg>
	)
}
